// External libraries
import React from 'react';
import { func } from 'prop-types';

// Internal modules
import { Name } from './Name';
import { Phone } from './Phone';
import { Email } from './Email';
import { SectionHeading } from '../Headings';
import { features, getContent } from '@/lib';

const ContactInfo = props => {
  /**
   * The users name is required for all flows as we normally we collect it with
   * the billing address fields. In flows where we are not collecting the
   * address we collect the name alongside the contact information fields.
   */
  const isAddressless = features.isActive('isAddressless');
  const showHeading = features.someActive('isGuestEligible', 'isPOMAEligible');

  return (
    <>
      {showHeading && (
        <SectionHeading>
          {getContent('billing.contactInformation')}
        </SectionHeading>
      )}

      {isAddressless && <Name {...props} />}

      <Phone {...props} />

      <Email {...props} />
    </>
  );
};

ContactInfo.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { ContactInfo };
